import GetSchedulerByRoomsRequestModel from '../../../generated/types/model/request/GetSchedulerByRoomsRequestModel';

export default class GetSchedulerByRoomsRequestViewModel extends GetSchedulerByRoomsRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
